import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { LoaderComponent } from './pages/shared/loader/loader.component';
import { ProfileService } from './services/profile.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'kokoro-vendor';
  constructor(private router: Router, private profileService: ProfileService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (event.url === '/undefined' || event.url.includes('undefined')) {
          this.router.navigate(['/vendor/dashboard']);
        }
      }
    });
  }

    ngOnInit(): void {
    // this.profileService.loadProfile();
  }
}
